<template>
  <div class="clinicservicelist">
    <b-container fluid>
      <b-row class="mycontainer-main ">
        <b-col cols="12" lg="4" class="pl-5 leftcontent main-background">
          <h1> {{ $t('p-services.jumbo-title') }} </h1>
          <h1 class="pageSubtitle"> {{ $t('p-services.jumbo-message1') }} </h1>
          <b-button squared variant="outline-dark" class="mt-3 shadow" @click="goBack"> {{ $t('common.goback')
            }}</b-button>
        </b-col>

        <b-col cols="12" lg="7" class="py-3">
          <div class="my-grid">
            <b-card v-for="(s, index) in serviceList" :key="index" img-top :img-src="getImg(s.img)" class="shadow">
              <!-- <b-card-img top :src="getImg('retail-clinic')" > </b-card-img> -->

              <b-card-title style="font-weight: bold;">{{ s.name }} <b-badge v-if="s.new" variant="warning"
                  style="font-size: 11px; vertical-align: top">{{ s.new }}</b-badge>
              </b-card-title>
              <b-card-text class="d-flex flex-column"> {{ s.desc }} </b-card-text>
              <b-button squared style="background-color: black;" class="main-button shadow clobutton"
                @click="serviceDetail(s.name)"> {{ $t('common.view') }} {{ s.name }} </b-button>

            </b-card>
            <b-card class="shadow">
              <!-- <b-card-img top :src="getImg('retail-clinic')" > </b-card-img> -->
              <b-card-title style="font-weight: bold;"> {{ $t('services.dontsee') }} </b-card-title>
              <b-card-text> {{ $t('services.help') }} </b-card-text>
              <b-button squared style="background-color: black;" class="main-button shadow" to="/appointment">
                {{ $t('services.helpbtn') }}</b-button>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

const enData = [

  { name: "Facials", desc: "The ultimate experience", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (5).jpg" },
  { name: "Hydrafacial ", desc: "Skin transforming treatments", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/BI_petit format_3.jpg", new: "New" },
  { name: "Microdermabrasion", desc: "Deeper cleaning", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_2.jpg" },
  { name: "Microneedling", desc: "Advanced technology for skin concerns", img: "s_microneedling" },
  { name: "Peelings", desc: "Acids and enzymes", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (21).jpg" },
  { name: "Hair Removal", desc: "Traditional and definitive hair removal", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/services/epilation.jpg" },
  { name: "Photofacial", desc: "Advanced technology for skin concerns", img: "s_photofacial" },

]

const frData = [
  { name: "Les soins du visage", desc: "L’expérience ultime", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (5).jpg" },
  { name: "Hydrafacial", desc: "Traitements de transformation", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/BI_petit format_3.jpg", new: "Nouveau" },
  { name: "Microdermabrasion", desc: "Le nettoyage en profondeur", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_2.jpg" },
  { name: "Microneedling", desc: "Thérapie par micro-aiguilles", img: "s_microneedling" },
  { name: "Les Peelings", desc: "Les acides et enzymes", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (21).jpg" },
  { name: "Épilation", desc: "Traditionelle et définitive", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/services/epilation.jpg" },
  { name: "Photofacial", desc: "La correction de la peau", img: "s_photofacial" },

]


export default {
  name: 'clinicservicelist',
  props: {
    serviceType: String
  },
  data() {
    return {
      servicePicked: '',
      serviceList: ''
    }
  },
  methods: {
    setService(n) {
      this.servicePicked = n

    },
    getImg(p) {
      //if imag starts with http, then it is a full url
      if (p.startsWith("http")) {
        return p
      }

      var images = require.context('../assets/images/services/', false, /\.jpg$/)
      return images('./' + p + ".jpg")
    },
    getBrandUrl(p) {
      var images = require.context('../assets/images/brands/', false, /\.jpg$/)
      return images('./' + p + ".jpg")
    },
    goBack() {
      this.$router.go(-1)
    },
    serviceDetail(n) {
      var serv = n
      this.$router.push({ name: 'servicedetail', params: { service: n } })
    },
    getData() {
      if (this.$i18n.locale == 'fr') {
        this.serviceList = frData;
      }
      else this.serviceList = enData
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
  created() {
  },
  mounted() {
    this.getData()
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: calc(90vh);
}

.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
}

.main-background {
  background-image: url('../assets/images/background2.png');
  background-repeat: no-repeat;
  background-position: right;
  background-size: 40%;
}

.card-img-top {
  width: 100%;
  height: 15rem;
  object-fit: cover;
}

.clobutton {
  text-transform: lowercase;
}

.my-grid {
  display: grid;
  justify-items: center;
  /* 280px is the minimum a column can get, you might need to adjust it based on your needs. */
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
}

.my-grid>* {
  width: 100%;
  max-width: 20rem;
}

@media screen and (max-width: 600px) {
  .leftcontent {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/ClinicServiceList.vue